import React from "react";
import { useI18n } from "../../providers/I18nProvider";
import { FilterBar, FilterField, SearchInput } from "../ListToolbar";
import { SAT_CATEGORIES, SAT_PRIORITIES, SAT_STATUSES } from "../../services/satRequestService";

// SAT listeleri için ortak filtre çubuğu (kullanıcının kendi listesi + admin listesi).
const SatFilterBar = ({ list, showRequester = false, showStage = false }) => {
  const { t } = useI18n();
  const { filters, setFilter, sort, setSort, hasActive, reset } = list;
  return (
    <FilterBar showReset={hasActive} onReset={reset}>
      <SearchInput
        value={filters.search}
        onChange={(v) => setFilter("search", v)}
        placeholder={t(showRequester ? "satList.filters.search" : "satList.filters.searchMine")}
      />
      <select
        className="leaves-filter-input lt-input"
        value={filters.category}
        onChange={(e) => setFilter("category", e.target.value)}
        aria-label={t("satRequest.fields.category")}
      >
        <option value="">{t("satList.filters.allCategories")}</option>
        {SAT_CATEGORIES.map((c) => (
          <option key={c} value={c}>
            {t(`satRequest.category.${c}`)}
          </option>
        ))}
      </select>
      <select
        className="leaves-filter-input lt-input"
        value={filters.priority}
        onChange={(e) => setFilter("priority", e.target.value)}
        aria-label={t("satRequest.fields.priority")}
      >
        <option value="">{t("satList.filters.allPriorities")}</option>
        {SAT_PRIORITIES.map((p) => (
          <option key={p} value={p}>
            {t(`satRequest.priority.${p}`)}
          </option>
        ))}
      </select>
      {showStage && (
        <select
          className="leaves-filter-input lt-input"
          value={filters.status}
          onChange={(e) => setFilter("status", e.target.value)}
          aria-label={t("satRequest.fields.status")}
        >
          <option value="">{t("satList.filters.allStages")}</option>
          {SAT_STATUSES.map((s) => (
            <option key={s} value={s}>
              {t(`satRequest.status.${s}`)}
            </option>
          ))}
        </select>
      )}
      <FilterField label={t("satList.filters.from")}>
        <input type="date" value={filters.from} onChange={(e) => setFilter("from", e.target.value)} />
      </FilterField>
      <FilterField label={t("satList.filters.to")}>
        <input type="date" value={filters.to} onChange={(e) => setFilter("to", e.target.value)} />
      </FilterField>
      <select
        className="leaves-filter-input lt-input"
        value={sort}
        onChange={(e) => setSort(e.target.value)}
        aria-label={t("satList.filters.sort")}
      >
        <option value="newest">{t("satList.filters.sortNewest")}</option>
        <option value="oldest">{t("satList.filters.sortOldest")}</option>
        <option value="priority">{t("satList.filters.sortPriority")}</option>
        <option value="priceDesc">{t("satList.filters.sortPriceDesc")}</option>
        <option value="priceAsc">{t("satList.filters.sortPriceAsc")}</option>
      </select>
    </FilterBar>
  );
};

export default SatFilterBar;
